// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__11uNq","newExpiryDate":"styles_newExpiryDate__3LG3t","footer":"styles_footer__SHs5z"};